import React from 'react'

export const ProgressBar = ({className = "progress is-small is-info"}) => {
    return (
        <>
            <progress className={ className } max="100">60%</progress>
        </>
    )
}